import React from 'react';
import RentalLanding from './pages/RentalLanding';
import DiscoveryTracker from './components/analytics/DiscoveryTracker';
import DriverDirectory, { DriverDetails } from './pages/DriverDirectory';
import DriverPortal from './pages/DriverPortal';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import Login from './pages/Login';
import Register from './pages/Register';
import OTPVerification from './pages/OTPVerification';
import AccountVerification from './pages/AccountVerification';
import BrowseFleet from './pages/BrowseFleet';
import CarDetails from './pages/CarDetails';
import InitiatePayment from './pages/InitiatePayment';
import PaymentComplete from './pages/PaymentComplete';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PublicInfoPage from './pages/PublicInfoPage';
import MyBookings from './pages/MyBookings';
import RenterDashboard from './pages/RenterDashboard';
import DriverDashboard from './pages/DriverDashboard';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import RenterWishlist from './pages/RenterWishlist';
import RenterPayments from './pages/RenterPayments';
import RenterRefunds from './pages/RenterRefunds';
import RenterNotifications from './pages/RenterNotifications';
import CarOwnerDashboard from './pages/CarOwnerDashboard';
import AddVehicle from './pages/AddVehicle';
import MyFleet from './pages/MyFleet';
import Finances from './pages/Finances';
import VehicleDetailsOwner from './pages/VehicleDetailsOwner';
import OwnerBookings from './pages/OwnerBookings';
import OwnerSettings from './pages/OwnerSettings';

import ProtectedRoute from './components/layout/ProtectedRoute';
import AppAlertHost from './components/ui/AppAlertHost';
import CustomerSupportChat from './components/ui/CustomerSupportChat';
import GoogleAnalyticsTracker from './components/analytics/GoogleAnalyticsTracker';


function App() {
  return (
    <BrowserRouter>
      <GoogleAnalyticsTracker />
      <DiscoveryTracker />
      <AppAlertHost />
      <CustomerSupportChat />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/careers" element={<PublicInfoPage pageKey="careers" />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faqs" element={<PublicInfoPage pageKey="faqs" />} />
        <Route path="/privacy-policy" element={<PublicInfoPage pageKey="privacy" />} />
        <Route path="/terms-of-service" element={<PublicInfoPage pageKey="terms" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify" element={<OTPVerification />} />
        <Route path="/browse" element={<BrowseFleet />} />
        <Route path="/car/:id/:slug" element={<CarDetails />} />
        {['car-rental-kigali','suv-rental-rwanda','car-rental-with-driver'].map(key => <Route key={key} path={`/${key}`} element={<RentalLanding pageKey={key}/>}/>)}
        <Route path="/car/:id" element={<CarDetails />} />
        <Route path="/payment-complete" element={<PaymentComplete />} />
        <Route path="/account-verification" element={
          <ProtectedRoute allowUnverified>
            <AccountVerification />
          </ProtectedRoute>
        } />

        <Route path="/drivers" element={<DriverDirectory />} />
        <Route path="/drivers/:id" element={<DriverDetails />} />
        <Route path="/driver-dashboard" element={<ProtectedRoute><DriverDashboard /></ProtectedRoute>} />
        <Route path="/driver" element={<ProtectedRoute><DriverDashboard /></ProtectedRoute>} />
        <Route path="/driver-trips" element={<ProtectedRoute><DriverPortal /></ProtectedRoute>} />
        <Route path="/account/settings" element={<ProtectedRoute><OwnerSettings /></ProtectedRoute>} />
        <Route path="/account/notifications" element={<ProtectedRoute><RenterNotifications /></ProtectedRoute>} />
        {/* Renter Protected Routes */}
        <Route path="/checkout/:id" element={
          <ProtectedRoute allowedRoles={['RENTER']}>
            <InitiatePayment />
          </ProtectedRoute>
        } />
        <Route path="/bookings" element={
          <ProtectedRoute allowedRoles={['RENTER']}>
            <MyBookings />
          </ProtectedRoute>
        } />
        <Route path="/renter-dashboard" element={
          <ProtectedRoute allowedRoles={['RENTER']}>
            <RenterDashboard />
          </ProtectedRoute>
        } />
        <Route path="/renter/payments" element={
          <ProtectedRoute allowedRoles={['RENTER']}>
            <RenterPayments />
          </ProtectedRoute>
        } />
        <Route path="/renter/wishlist" element={
          <ProtectedRoute allowedRoles={['RENTER']}>
            <RenterWishlist />
          </ProtectedRoute>
        } />
        <Route path="/renter/refunds" element={
          <ProtectedRoute allowedRoles={['RENTER']}>
            <RenterRefunds />
          </ProtectedRoute>
        } />
        <Route path="/renter/notifications" element={
          <ProtectedRoute allowedRoles={['RENTER']}>
            <RenterNotifications />
          </ProtectedRoute>
        } />
        <Route path="/renter/settings" element={
          <ProtectedRoute allowedRoles={['RENTER']}>
            <OwnerSettings />
          </ProtectedRoute>
        } />

        {/* Owner Protected Routes */}
        <Route path="/owner-dashboard" element={
          <ProtectedRoute allowedRoles={['CAR_OWNER']}>
            <CarOwnerDashboard />
          </ProtectedRoute>
        } />
        <Route path="/add-vehicle" element={
          <ProtectedRoute allowedRoles={['CAR_OWNER']}>
            <AddVehicle />
          </ProtectedRoute>
        } />
        <Route path="/fleet" element={
          <ProtectedRoute allowedRoles={['CAR_OWNER']}>
            <MyFleet />
          </ProtectedRoute>
        } />
        <Route path="/finances" element={
          <ProtectedRoute allowedRoles={['CAR_OWNER']}>
            <Finances />
          </ProtectedRoute>
        } />
        <Route path="/owner/car/:id" element={
          <ProtectedRoute allowedRoles={['CAR_OWNER']}>
            <VehicleDetailsOwner />
          </ProtectedRoute>
        } />
        <Route path="/owner/bookings" element={
          <ProtectedRoute allowedRoles={['CAR_OWNER']}>
            <OwnerBookings />
          </ProtectedRoute>
        } />
        <Route path="/owner/settings" element={
          <ProtectedRoute allowedRoles={['CAR_OWNER']}>
            <OwnerSettings />
          </ProtectedRoute>
        } />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
